import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, BadInputError } from '@digibricks/core';
export var ScoreVisibilityType = /*#__PURE__*/function (_ValueObject) {
  _inherits(ScoreVisibilityType, _ValueObject);

  var _super = _createSuper(ScoreVisibilityType);

  function ScoreVisibilityType() {
    _classCallCheck(this, ScoreVisibilityType);

    return _super.apply(this, arguments);
  }

  _createClass(ScoreVisibilityType, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }, {
    key: "isImmediateView",
    value: function isImmediateView() {
      return this.props === ScoreVisibilityType.values[1];
    }
  }, {
    key: "isPublishScoreManually",
    value: function isPublishScoreManually() {
      return this.props === ScoreVisibilityType.values[0];
    }
  }], [{
    key: "create",
    value: function create(value) {
      if (!value || value !== this.values[0] && value !== this.values[1]) {
        return new BadInputError("Invalid Result Visibility: ".concat(value));
      }

      return Result.ok(new ScoreVisibilityType(value));
    }
  }]);

  return ScoreVisibilityType;
}(ValueObject);

_defineProperty(ScoreVisibilityType, "values", ['1', // teacher Manual Release
'2' // student immediate view after submit
]);

_defineProperty(ScoreVisibilityType, "manualPublishScore", ScoreVisibilityType.create(ScoreVisibilityType.values[0]).getValue());

_defineProperty(ScoreVisibilityType, "immediateViewAfterSubmit", ScoreVisibilityType.create(ScoreVisibilityType.values[1]).getValue());